/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WizardStepComponent} from '../../../shared/wizard/wizard-step.component';
import {WizardService} from '../../../shared/wizard/wizard.service';
import {StepClaimInformationModel} from './step-claim-information.model';
import {WizardIconEnum} from '../../../shared/wizard/wizard-icon.enum';
import {Subscription} from 'rxjs';
import {ClaimInformationDataModel} from '../../models/claim-information-data.model';
import {FileSummaryModel} from '../../../api/ms-filemanager/contracts/file-summary.model';

@Component({
    selector: 'app-step-claim-information',
    templateUrl: './step-claim-information.component.html',
    styleUrls: ['./step-claim-information.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepClaimInformationComponent extends WizardStepComponent implements OnInit, OnDestroy {
    @Input() stepIndex: number;
    public isLoading = false;
    stepModel = {
        canSave: false,
        canSend: false,
        icon: WizardIconEnum.NONE,
        data: {}
    } as StepClaimInformationModel;

    private subscriptions = new Subscription();

    private formValues: ClaimInformationDataModel;

    constructor(wizardService: WizardService) {
        super(wizardService);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    setFormValue = (form: ClaimInformationDataModel): void => {
        this.formValues = form;
        this.updateStepData();
    };

    setAttachmentsValue = (attachments: FileSummaryModel[]): void => {
        this.stepModel.data.attachments = attachments;
    };

    isValidForSend(canSend: boolean): void {
        this.stepModel.canSend = canSend;
        this.updateStepData();
    }

    isTouched(isTouched: boolean): void {
        this.stepModel.isTouched = isTouched;
        this.updateStepData();
    }

    isValidForSave(canSave: boolean): void {
        this.stepModel.canSave = canSave;
        this.updateStepData();
    }

    formIsLoading(loading: boolean): void {
        this.isLoading = loading;
    }

    private updateStepData(): void {
        this.setStepIcon();

        this.stepModel.data.partner = this.formValues?.partner;
        this.stepModel.data.claimCode = this.formValues?.claimCode;
        this.stepModel.data.description = this.formValues?.description?.length > 0 ? this.formValues.description : null;
        this.stepModel.data.material = this.formValues?.material;
        this.stepModel.data.lotNumber = this.formValues?.lotNumber?.length > 0 ? this.formValues.lotNumber : null;
        this.stepModel.data.mcdrNumber = this.formValues?.mcdrNumber?.length > 0 ? this.formValues.mcdrNumber : null;
        this.stepModel.data.modelCode = this.formValues?.modelCode?.length > 0 ? this.formValues.modelCode : null;
        this.stepModel.data.modelType = this.formValues?.modelType?.length > 0 ? this.formValues.modelType : null;
        this.stepModel.data.subject = this.formValues?.subject?.length > 0 ? this.formValues.subject : null;
        this.stepModel.data.supplyingPackingPlant = this.formValues?.supplyingPackingPlant;
        this.stepModel.data.attachmentDirectory = this.formValues?.attachmentDirectory;
        this.stepModel.data.spoNumber = this.formValues?.spoNumber?.length > 0 ? this.formValues.spoNumber : null;

        this.sendUpdateForm();
    }

    private setStepIcon(): void {
        if (this.stepModel.canSend) {
            this.stepModel.icon = WizardIconEnum.SUCCESS;
        } else if (this.stepModel.canSave) {
            this.stepModel.icon = WizardIconEnum.ERROR;
        }
    }

}
